import { render, staticRenderFns } from "./MiscSettings.vue?vue&type=template&id=d1577fd4&"
import script from "./MiscSettings.vue?vue&type=script&lang=ts&"
export * from "./MiscSettings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports